const columnsWidth = {
  commentColumn: '13%',
  attachementColumn: 'calc(15% - 30px - 2em)',
  bugsColumn: '12%',
  statusColumn: '10%',
  checkboxColumn: '30px',
};

export default columnsWidth;
